import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { FertilizerProductId } from 'services/fertilizerEvents/types';
import { OwnProps } from './index';
import { selectFertilizerWorksheetProductsKeyedById } from '../../../../selectors';

const selectProductId = (
    state: AppState,
    props: OwnProps
): FertilizerProductId => props.productId;

const selectProductOrder = createDeepEqualSelector(
    selectFertilizerWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) =>
        get(productsKeyedById, [productId, 'orderIndex'])
);

const makeSelectProductOrder = (): typeof selectProductOrder =>
    selectProductOrder;

export { selectProductId, makeSelectProductOrder };
